import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./auth.css";
import video from "../../assets/hero-video.mp4";
import logo from "../../assets/ZAUNTRIP-Logo.png"; // Import your logo

const API_BASE = "https://crmapi.zauntrip.com/api/auth";

const CreateUser = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    password: "",
    isAdmin: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_BASE}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Registration failed");
      }

      alert("User created successfully!");
      navigate("/signin");
    } catch (err) {
      setError(err.message || "Registration failed. Please try again.");
      console.error("Registration error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      {/* Left Video Section */}
      <div className="video-section">
        <video 
          className="video-background" 
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source 
            src={video}
            type="video/mp4" 
          />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
        <div className="logo-container">
          {/* Your actual logo */}
          <img 
            src={logo} 
            alt="ZaunTrip Logo" 
            style={{ 
              width: '200px', 
              height: 'auto',
              marginBottom: '20px'
            }} 
          />
          <h1>ZaunTrip CRM</h1>
          <p>Streamline your customer relationship management with our powerful tools and intuitive interface.</p>
        </div>
      </div>

      {/* Right Form Section */}
      <div className="form-section">
        <form className="auth-card" onSubmit={handleSubmit}>
          <h2>Create New User</h2>
          
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="full_name">Full Name *</label>
            <input
              id="full_name"
              name="full_name"
              type="text"
              placeholder="Enter full name"
              value={form.full_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="Enter email address"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input
              id="password"
              name="password"
              type="password"
              placeholder="Enter password"
              value={form.password}
              onChange={handleChange}
              required
              minLength="6"
            />
            <small className="password-hint">Password must be at least 6 characters</small>
          </div>

          {/* <div className="form-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="isAdmin"
                checked={form.isAdmin}
                onChange={handleChange}
              />
              <span>Admin User</span>
            </label>
            <small className="checkbox-hint">Admin users require OTP verification on login</small>
          </div> */}

          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading}
          >
            {loading ? "Creating User..." : "Create User"}
          </button>

          <div className="auth-footer">
            <p className="auth-link" onClick={() => navigate("/signin")}>
              Already have an account? <span>Sign In</span>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUser;